import styled from 'styled-components';

import { BaseStyle, BaseStyleEnums } from '@nhl/nhl-breakaway-ui';

export const SIZES = {
    gameLinks: {
        shadowSize: 20,
        iconSize: 50,
        maxSize: 340,
        minSize: 140,
        size: 180,
    },
    gameNumberAndDate: {
        size: 120,
    },
    teamMatchup: {
        smallSize: 288,
        size: 466,
    },
};

export const ReactTableContainer = styled.div`
    margin: 24px 0 24px 0;

    .rt-thead {
        height: 40px;
        display: none;
    }

    .rt-tbody {
        width: 100%;

        .rt-tr:first-child {
            border-top: 1px solid ${({ theme }) => theme.Surface.border};
        }

        .rt-tr {
            width: 100%;
            min-height: 80px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid ${({ theme }) => theme.Surface.border};
            flex-direction: column;

            ${BaseStyle.Mixins.screenSizes.large} {
                flex-direction: row;
            }
        }

        .rt-tr:last-child {
            border-bottom: none;
        }
    }

    @media (max-width: ${BaseStyleEnums.ScreenWidthBreakpoints.large - 1}px) {
        .playoffSeriesColumn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            max-width: initial;
            min-width: initial;
        }
    }
`;
export const GameNumberDateContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 8px 0 8px 0;

    ${BaseStyle.Mixins.screenSizes.large} {
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        padding: 18px;
    }
`;

export const GameNumber = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}
    line-wrap: nobreak;
    white-space: nowrap;

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.ui['14b']}
        margin-bottom: 4px;
    }
`;
export const GameDate = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}
    display: flex;
    flex-direction: row;
    line-wrap: nobreak;
    white-space: nowrap;

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.desktop.body3}
    }
`;

export const SeriesStatusMessage = styled.div`
    width: 100%;
    padding-bottom: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        padding: 0;
        justify-content: flex-start;
    }
`;
